<template>
  <div class="commonTable">
    <!-- 高级筛选抽屉弹窗 -->
    <el-drawer
      title="高级筛选"
      :visible.sync="showExtraSearch"
      direction="rtl"
      ref="drawer"
      size="50%"
      :wrapperClosable="true"
      custom-class="ct-advanced-draw"
    >
      <el-form :inline="true" class="demo-form-inline" v-if="advancedSearchColumn && advancedSearchColumn.length">

        <el-form-item
          v-for="search in [...searchColumn, ...advancedSearchColumn].filter((item) => item.type !== 'none')"
          :key="search.prop"
        >
          <el-select
            v-if="search.type === 'select'"
            v-model="searchValue[search.prop]"
            filterable
            clearable
            :placeholder="search.label"
          >
            <el-option
              v-for="(select, i) in search.option"
              :value="select.value"
              :label="select.label"
              :key="i"
            ></el-option>
          </el-select>
          <el-date-picker
            v-else-if="search.type === 'date'"
            v-model="timerange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :name="search.prop"
            @change="(val) => {
              changeDate(search.prop, val)
            }"
          >
          </el-date-picker>
          <el-date-picker
            v-else-if="search.type === 'dateone'"
            v-model="searchValue[search.prop]"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="search.label"
          >
          </el-date-picker>
          <el-date-picker
            v-else-if="search.type === 'datetwice'"
            v-model="twice"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="search.label"
            @change="(val) => {
              search.prop.split('+').map(key => {
                searchValue[key] = val
              })
            }"
            :clearable="false"
          >
          </el-date-picker>
          <el-input
            v-else
            :placeholder="search.label"
            v-model="searchValue[search.prop]"
          ></el-input>
        </el-form-item>

        <slot name="search-back" :searchValue="searchValue" />

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchDataList"
            >查询</el-button>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-refresh-left" @click="reset()">重置</el-button>
        </el-form-item>

        <slot
          name="search"
          :searchValue="searchValue"
          :totalRecords="totalRecords"
        />
      </el-form>
    </el-drawer>
    <div class="search" v-if="searchColumn && searchColumn.length">
      <el-form :inline="true" class="demo-form-inline">
        <slot name="search-front" :searchValue="searchValue" />

        <el-form-item
          v-for="search in searchColumn.filter((item) => item.type !== 'none')"
          :key="search.prop"
        >
          <el-select
            v-if="search.type === 'select'"
            v-model="searchValue[search.prop]"
            filterable
            clearable
            :placeholder="search.label"
          >
            <el-option
              v-for="(select, i) in search.option"
              :value="select.value"
              :label="select.label"
              :key="i"
            ></el-option>
          </el-select>
          <el-date-picker
            v-else-if="search.type === 'date'"
            v-model="timerange"
            :timerange="timerange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            :start-placeholder="search.label.split('+')[0]"
            :end-placeholder="search.label.split('+')[1]"
            :name="search.prop"
            @change="(val) => {
              changeDate(search.prop, val)
            }"
          >
          </el-date-picker>
          <el-date-picker
            v-else-if="search.type === 'datetime'"
            v-model="timerange"
            :timerange="timerange"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            :start-placeholder="search.label.split('+')[0]"
            :end-placeholder="search.label.split('+')[1]"
            :name="search.prop"
            @change="(val) => {
              changeDate(search.prop, val)
            }"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
          <el-date-picker
            v-else-if="search.type === 'dateone'"
            v-model="searchValue[search.prop]"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="search.label"
          >
          </el-date-picker>
          <el-date-picker
            v-else-if="search.type === 'datetwice'"
            v-model="twice"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="search.label"
            @change="(val) => {
              search.prop.split('+').map(key => {
                searchValue[key] = val
              })
            }"
            :clearable="false"
          >
          </el-date-picker>
          <el-input
            v-else
            :placeholder="search.label"
            v-model="searchValue[search.prop]"
          ></el-input>
        </el-form-item>
        
        <slot name="search-back" :searchValue="searchValue" />

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchDataList"
            >查询</el-button>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-refresh-left" @click="reset()">重置</el-button>
        </el-form-item>

        <el-form-item v-if="advancedSearch">
          <el-button type="text" @click="showExtraSearch = true">
            <i class="el-icon-magic-stick"></i>
            高级筛选
          </el-button>
        </el-form-item>

        <slot
          name="search"
          :searchValue="searchValue"
          :totalRecords="totalRecords"
        />
      </el-form>
    </div>
    <slot
      name="summary"
      :summaryData="summaryData"
    />
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 99%"
      @selection-change="handleSelectionChange"
      :cell-style="cellStyle"
      :key="changeKey"
      :show-summary="summary"
      :summary-method="getSummaries"
    >
      <el-table-column
        fixed
        type="selection"
        width="55"
        v-if="canMultiple"
      ></el-table-column>
      <el-table-column
        v-for="item, index in column"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :formatter="item.formatter || formatter"
        :fixed="item.fixed"
        :width="item.width"
      >
        <template slot="header">
          <el-popover
            v-if="item.info"
            placement="top-start"
            title="说明："
            width="200"
            trigger="hover"
            :content="item.info"
          >
            <div slot="reference">
              <span>{{ item.label }}</span>
              <i class="el-icon-info ct-icon-info"></i>
            </div>
          </el-popover>
          <span v-else>{{ item.label }}</span>
        </template>
      </el-table-column>

      <slot />
    </el-table>

    <div class="pagination" style="margin-top: 10px;">
      <div>
        <template v-if="canMultiple">
          <el-button @click="$refs.table.toggleAllSelection()">选择全部</el-button>
          <el-button @click="toggleSelection(tableData)">反向选择</el-button>
          <el-dropdown v-if="multipleDropdown && multipleDropdown.length"
                        @command="handleCommand"
                        trigger="hover" placement="top-start">
            <el-button style="margin-left: 10px;">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in multipleDropdown"
                :key="item.command"
                :command="item.command">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import fetch from "@/assets/js/axios.js";
import moment from "moment"

export default {
  name: "commonTable",
  data() {
    return {
      showExtraSearch: false,
      timerange: [],
      searchTemplate: {},
      searchValue: {},
      loadingData: false,
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      multipleSelection: [],
      tableData: [],
      tableHeight: 0,
      summaryData: null,
      changeKey: new Date().getTime(),
      // 合计数据
      summaryData: {},
      twice: null,
    };
  },
  props: {
    // 高级筛选
    advancedSearchColumn: Array,
    // 特殊的页面数参数名
    limitKey: String,
    // 额外参数
    extraParams: Object,
    // 显示批量选择
    canMultiple: Boolean,
    // 批量选择-更多操作
    multipleDropdown: Array,
    // 请求列表url
    url: {
      require: true,
      type: String,
    },
    // 显示的列表参数
    column: {
      require: true,
      type: Array,
      default() {
        return [
          {
            label: "",
            prop: "",
          },
        ];
      },
    },
    // 搜索参数
    searchColumn: Array,
    reqMethod: {
      default: 'POST'
    },
    isList: Boolean,
    // 合计
    summary: Boolean,
    // 合计名称
    summaryLabel: {
      type: String,
      default: '合计'
    },
  },
  beforeMount() {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 120; //减去页面上固定高度height
  },
  mounted() {
    const searchColumn = this.searchColumn
    if (searchColumn && searchColumn.length) {
      searchColumn.forEach((item) => {
        const dateKey = item.prop.split("+")
        if (["date", "datetime"].includes(item.type) ) {
          // const defaulTime = ['00:00:00', '23:59:59']
          dateKey.forEach((date, index) => {
            let val = ''
            if (item.setDefault) {
              val = this.$moment(new Date()).format("YYYY-MM-DD ")
            } else if (item.setDefaultWeek){
              val = index ? this.$moment(new Date()).format("YYYY-MM-DD ") + '00:00:00' : this.$moment().subtract(7, 'days').format("YYYY-MM-DD ") + '23:59:59'
            }
            this.timerange.push(val)
            this.searchTemplate[date] = val
          })
        } else if (item.type === "dateone") {
          this.searchTemplate[item.prop] = this.$moment(new Date()).format("YYYY-MM-DD")
        } else if (item.type === "datetwice") {
          this.twice = this.$moment(new Date()).format("YYYY-MM-DD")
          dateKey.forEach((date, index) => {
            this.searchTemplate[date] = this.twice
          })
        } else {
          this.searchTemplate[item.prop] = "";
        }
      });
      this.searchValue = _.cloneDeep(this.searchTemplate);
    }
    this.getDataList();
  },
  computed: {
    advancedSearch () {
      return this.advancedSearchColumn && this.advancedSearchColumn.length
    }
  },
  methods: {
    // 获取合计数据
    getSummaries(param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        const { property } = column
        const targetColumn = this.column.find(item => item.prop === property)
        const targetValue = this.summaryData && this.summaryData[property]
        let value = targetValue ? targetValue :''
        if (value && targetColumn && targetColumn.formatter) {
          value = targetColumn.formatter(0, 0, value)
        }
        sums[index] = index === 0 && !Boolean(value) ? this.summaryLabel : value
      })
      return sums
    },
    // 获取数据
    getValue (obj, key) {
      const keyList = key.split('.')
      if (!obj) return '-'
      if (keyList.length === 1) return obj[key]
      let value = '-'
      for (let i = 0; i < keyList.length; i++) {
        const keyItem = keyList[i]
        if (i === 0) {
          const item = obj[keyItem]
          if (!item) return '-'
          value = item
        } else {
          value = value[keyItem]
        }
      }
      return value
    },
    cellStyle ({row, column}) {
      const findItem = this.column.find(item => item.prop === column.property)
      const val = row[column.property]
      return {color: val && findItem && findItem.color ? findItem.color(val) : '#606266'}
    },
    changeDate(name, value) {
      if (name) {
        name.split("+").forEach((item, index) => {
          this.searchValue[item] = value && value[index] ? value[index] : null
        })
      }
    },
    // 重载
    reload() {
      this.getDataList();
    },
    // 
    layout () {
      this.changeKey = new Date().getTime()
    },
    // 重置
    async reset() {
      this.searchValue = _.cloneDeep(this.searchTemplate);
      await this.$emit("reset");
      this.timerange = [];
      this.showExtraSearch = false
      this.currentPage = 1;
      this.getDataList();
    },
    // 搜索列表
    searchDataList() {
      this.showExtraSearch = false
      this.currentPage = 1;
      this.tableData = [];
      this.getDataList();
      this.$emit('onSearch')
    },
    // 分页相关
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDataList();
    },
    // 多选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.table.toggleRowSelection(row)
        });
      } else {
        this.$refs.table.clearSelection()
      }
    },
    handleCommand(command) {
      const list = this.multipleSelection
      if (list.length === 0) {
        this.$message('请勾选要操作的内容')
        return
      }
      const data = {
        command,
        list
      }
      this.$emit('handleMultipleCommand', data)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取列表数据
    getDataList() {
      const search = {}
      search[this.limitKey || 'limit'] = this.pageSize
      for (const key in this.searchValue) {
        const item = this.searchValue[key]
        if (item !== '') {
          search[key] = item
        }
      }
      this.loadingData = true;
      this.$emit('isLoading', true)
      fetch({
        url: this.url,
        method: this.reqMethod,
        params: {
          ...search,
          ...this.extraParams,
          page: this.currentPage
        },
      })
        .then((res) => {
          if (res.data.status && res.data.data) {
            let data = []
            let total = res.data.data.total
            if (this.summary) {
              const { list, collect } = res.data.data
              data = list.data
              this.summaryData = collect[0]
              total = list.total
            } else if (this.isList && res.data.data.data) {
              const { list, total } = res.data.data.data
              data = list
              this.summaryData = total
            } else {
              data = res.data.data.data
            }
            this.tableData = data
            this.totalRecords = total
            this.$emit('onGetData', data)
          }
        })
        .finally(() => {
          this.loadingData = false;
          this.$emit('isLoading', false)
        });
    },
    // 过滤操作
    formatter(row, column, cellValue, index) {
      return cellValue;
    },
  },
};
</script>

<style lang="less">
.commonTable {
  /deep/ .red {
    color: red;
  }
  .pagination{
    display: flex;
    text-align: left;
    justify-content: space-between;
  }
  .ct-icon-info {
    margin-left: 5px;
    color: #409eff;
    font-size: 14px;
  }
  .ct-advanced-draw {
    .el-drawer__header {
      background-color: rgba(245, 245, 245, 1);
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(233, 233, 233, 1);
      padding: 16px 20px;
    }
    .el-drawer__body {
      padding: 40px;
    }
  }
}
</style>
